export default __webpack_public_path__ + "static/media/desktop.10e6c567.svg";